var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        name: "addcard-modal",
        width: "100%",
        height: "auto",
        adaptive: true,
        "max-width": 450
      },
      on: {
        opened: _vm.opened,
        closed: _vm.closed,
        "before-open": _vm.beforeOpen
      }
    },
    [
      _c("div", [
        _c("div", { staticClass: "modal-header" }, [
          _c(
            "button",
            {
              staticClass: "close",
              on: {
                click: function($event) {
                  return _vm.$modal.hide("addcard-modal")
                }
              }
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "modal-body" }, [
          _c("div", { staticClass: "row d-flex" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "modal-title" }, [_vm._v("Add a Card")])
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "d-flex flex-column",
                  attrs: { id: "checkout-form" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 mt-2",
                      attrs: { id: "card-number-bootstrap" }
                    },
                    [
                      _c("label", [_vm._v("Card Number")]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "form-control",
                        attrs: { id: "card-number" }
                      }),
                      _vm._v(" "),
                      _c("label", {
                        staticClass: "help-block mt-1",
                        attrs: { for: "card-number", id: "card-number-error" }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-6 pl-0 mt-2",
                        attrs: { id: "card-expiry-bootstrap" }
                      },
                      [
                        _c("label", [_vm._v("Expiration Date")]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "form-control",
                          attrs: { id: "card-expiry" }
                        }),
                        _vm._v(" "),
                        _c("label", {
                          staticClass: "help-block mt-1",
                          attrs: { for: "card-expiry", id: "card-expiry-error" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "col-6 px-0 mt-2",
                        attrs: { id: "card-cvv-bootstrap" }
                      },
                      [
                        _c("label", [_vm._v("CVV")]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "form-control",
                          attrs: { id: "card-cvv" }
                        }),
                        _vm._v(" "),
                        _c("label", {
                          staticClass: "help-block mt-1",
                          attrs: { for: "card-cvv", id: "card-cvv-error" }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "d-flex col-xs-6 text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn add-btn disabled",
                        attrs: {
                          id: "pay-button",
                          type: "submit",
                          disabled: "true"
                        }
                      },
                      [_vm._v("\n                Save Card\n              ")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer mt-3" }, [
                    _c("span", { staticClass: "inc-text" }, [
                      _vm._v(
                        "\n                We use Bambora Inc. to process all credit card payments.\n                Processing a payment or saving a payment method to your\n                profile does not provide hungerhub Canada Inc. with access to\n                nor allow for the retention of any credit card information.\n              "
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e360c0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e360c0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddCardModal.vue
// module id = null
// module chunks = 